// HANDLE EXAMPLE FUNCTION FOR BULLETIN PREVIEW

import dayjs from "dayjs"

// Handle preview
const handleExample = (bulletin, split) => {
  if (bulletin) {
    let niceDate = dayjs(bulletin.start_time).format("DD.MM.YYYY HH:mm")
    if (bulletin.end_time) {
      let endDate = new Date(bulletin.end_time)
      if (endDate > 0) {
        let endDateNice = dayjs(bulletin.end_time).format("DD.MM.YYYY HH:mm")
        niceDate = niceDate + " - " + endDateNice
      }
    }

    let temp = new Object()
    temp.id = bulletin.id
    temp.date = niceDate

    temp.title = bulletin.header_fi
    temp.title_fi = bulletin.header_fi
    temp.title_en = bulletin.header_en
    temp.title_sv = bulletin.header_sv

    temp.content1_fi = bulletin.description_fi
      ? bulletin.description_fi.replace(/(?:\r\n|\r|\n)/g, "\n")
      : ""
    temp.content1_en = bulletin.description_en
      ? bulletin.description_en.replace(/(?:\r\n|\r|\n)/g, "\n")
      : ""
    temp.content1_sv = bulletin.description_sv
      ? bulletin.description_sv.replace(/(?:\r\n|\r|\n)/g, "\n")
      : ""
    temp.content1 = temp.content1_fi

    let targetGroups = []
    if (split) {
      const targetGroupsString = bulletin.target_groups
      targetGroups = targetGroupsString.split(",")
    } else {
      targetGroups = bulletin.target_groups
    }

    let targets = []
    for (const target of targetGroups) {
      switch (target) {
        case "1":
          targets.push("Suvanto Care app")
          break
        case "2":
          targets.push("Video call")
          break
        case "3":
          targets.push("Group video call")
          break
        case "4":
          targets.push("Carephone")
          break
        case "5":
          targets.push("Medicine reminder")
          break
        case "6":
          targets.push("Suvanto On the Go")
          break
        case "7":
          targets.push("Suvanto Home")
          break
        case "8":
          targets.push("Smartlock")
          break
        case "9":
          targets.push("Suvanto Care webpage")
          break
        case "10":
          targets.push("Smartwatch")
          break
      }
    }
    temp.targets = targets
    temp.current_status = bulletin.current_status
    switch (bulletin.current_status) {
      case 1:
      case "1":
        temp.status = "Service outage"
        temp.color = "#f46a6a"
        break
      case 2:
      case "2":
        temp.status = "Service disruption"
        temp.color = "#f1b44c"
        break
      case 3:
      case "3":
        temp.status = "Service operational"
        temp.color = "#34c38f"
        break
    }
    return temp
  }
}

export { handleExample }
